module.exports = __webpack_public_path__ + "img/no_data_org@2x.f1b3f40b.png";